import HttpRequest from './http_request'
import { getStoreId } from '@/utils/helper/localStorage'
import storeId from '@/config/new-member-store.js'
class PromotionProvider extends HttpRequest {
  constructor () {
    super(`${process.env.NEW_API}`)
  }

  async verifyPromotionCode (payload) {
    const validatePromotionCodePayload = {
      code: payload.code,
      member: {
        tel: payload.memberTel
      },
      items: payload.items.map(item => {
        return {
          sku_id: parseInt(item.id),
          code: item.code,
          name: item.name,
          amount: parseInt(item.amount),
          option: '',
          price: parseFloat(item.price),
          full_price: parseFloat(item.fullPrice),
          productId: parseInt(item.productId),
          brand: {
            id: 2,
            name: 'a'
          },
          warehouse: {
            id: payload.warehouse.id,
            name: payload.warehouse.name,
            code: payload.warehouse.code
          },
          categories: item.categories,
          tags: item.tags
        }
      }),
      channel: 'pos'
    }
    try {
      const newStore = storeId[getStoreId()] ? storeId[getStoreId()] : '000000000'
      const { data } = await this.create(`/public/${newStore.id}/promotion-codes/validate`, validatePromotionCodePayload)
      return data
    } catch (error) {
      return {
        data: { success: false,
          error: {
            message: error.response ? error.response.data.message : 'Server error or Incorect store.'
          }
        }
      }
    }
  }
}

export default PromotionProvider



// WEBPACK FOOTER //
// ./src/resources/promotion_provider.js